import { IELTDataSettings } from 'legacy/lut/classes/models/partner360/ELT/IELTData'
import { defaultActualValueTypes } from 'legacy/lut/components/widgets/public/partner360/ELT/configs'
import {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from 'react'

interface IEltDataSettingsContext {
  dataSettings: IELTDataSettings
  setDataSettings: Dispatch<SetStateAction<IELTDataSettings>>
}

const defaultValue: IELTDataSettings = {
  NetNdp: defaultActualValueTypes[0],
  ActualsValueTypes: defaultActualValueTypes,
  DisplayWarningForTypes: [],
  WarningKey: '',
}

const EltDataSettingsContext = createContext<IEltDataSettingsContext | null>(null)

export const EltDataSettingsProvider = ({ children }: PropsWithChildren) => {
  const [dataSettings, setDataSettings] = useState<IELTDataSettings>(defaultValue)

  const value = useMemo(
    () => ({
      dataSettings,
      setDataSettings,
    }),
    [dataSettings]
  )

  return <EltDataSettingsContext.Provider value={value}>{children}</EltDataSettingsContext.Provider>
}

export const useEltDataSettings = () => {
  const context = useContext(EltDataSettingsContext)

  if (!context) {
    throw new Error('useEltDataSettings must be used inside EltDataSettingsProvider')
  }

  return context
}
